// extracted by mini-css-extract-plugin
module.exports = {"indicator":"CarouselIndicator-module--indicator--1fsd_","selected":"CarouselIndicator-module--selected--3d80J"};